module.exports = __webpack_public_path__ + "img/e-commerce.36c0b50b.png";